module.exports = __webpack_public_path__ + "static/clouds-7ac5d766cf6848c1d7da4af0055c06be.mp4";